import { DateObj } from 'dayzed';
import { startOfDay, isWithinInterval, isEqual, addDays } from 'date-fns';
import { ButtonStyleVariant, ValuesRef } from '../types';

const MAX_SELECTABLE_DAYS = 29;

function firstBlockedDateInRange(start: Date, end: Date, blockedDates: Date[]) {
  for (const blockedDate of blockedDates) {
    if (isWithinInterval(blockedDate, { start, end })) {
      return blockedDate;
    }
  }
}

export function getVariant(values: ValuesRef, dateObj: DateObj): ButtonStyleVariant {
  const date = startOfDay(dateObj.date);
  const { props, draftDates, highlightedDates, selectionMode } = values.current;

  // if outside dayzed min - max range
  if (!dateObj.selectable) return 'disabled';

  if (draftDates.endDate && isEqual(date, draftDates.endDate)) {
    return 'end';
  }

  if (draftDates.startDate && isEqual(date, draftDates.startDate)) {
    return 'start';
  }

  // if date is over max stay size
  if (
    selectionMode === 'end' &&
    draftDates.startDate &&
    date > draftDates.startDate &&
    date >= addDays(draftDates.startDate, MAX_SELECTABLE_DAYS)
  ) {
    return 'disabled';
  }

  // if there exists a blocked date between start and this date
  if (selectionMode === 'end' && draftDates.startDate && props.blockedDates && date > draftDates.startDate) {
    const firstBlockedDate = firstBlockedDateInRange(draftDates.startDate, date, props.blockedDates);
    if (firstBlockedDate) {
      if (isEqual(firstBlockedDate, date)) {
        return 'selectable';
      } else {
        return 'disabled';
      }
    }
  }

  if (props.blockedDates?.some((blockedDate) => isEqual(blockedDate, date))) {
    return 'blocked';
  }

  if (
    highlightedDates.startDate &&
    highlightedDates.endDate &&
    isWithinInterval(date, { start: highlightedDates.startDate, end: highlightedDates.endDate })
  ) {
    return 'highlighted';
  }

  return 'selectable';
}
